import { aiDashboardApi } from './ai-dashboard';
import { authApi } from './auth';
import { controlGenApi } from './controlgen';
import { documentsApi } from './documents';
import { nodeAuthApi } from './node-auth';
import { nodeGenAiTestApi } from './node-genai';
import { nodeTaskApi } from './node-task';
import { organizationApi } from './organization';
import { pythonTaskApi } from './python-task';
import { reportGeneratorApi } from './report-generator';
import { userInviteApi } from './user-invite';
import { userProfileApi } from './user-profile';

// Aggregate list of API reducers
export const apiReducers = {
  [authApi.reducerPath]: authApi.reducer,
  [userProfileApi.reducerPath]: userProfileApi.reducer,
  [userInviteApi.reducerPath]: userInviteApi.reducer,
  [organizationApi.reducerPath]: organizationApi.reducer,
  [reportGeneratorApi.reducerPath]: reportGeneratorApi.reducer,
  [aiDashboardApi.reducerPath]: aiDashboardApi.reducer,
  [nodeAuthApi.reducerPath]: nodeAuthApi.reducer,
  [nodeTaskApi.reducerPath]: nodeTaskApi.reducer,
  [nodeGenAiTestApi.reducerPath]: nodeGenAiTestApi.reducer,
  [pythonTaskApi.reducerPath]: pythonTaskApi.reducer,
  [documentsApi.reducerPath]: documentsApi.reducer,
  [controlGenApi.reducerPath]: controlGenApi.reducer,
};

export const apiSlices = [
  authApi,
  userProfileApi,
  userInviteApi,
  organizationApi,
  reportGeneratorApi,
  aiDashboardApi,
  nodeAuthApi,
  nodeTaskApi,
  nodeGenAiTestApi,
  pythonTaskApi,
  documentsApi,
  controlGenApi,
];

export {
  authApi,
  userProfileApi,
  userInviteApi,
  organizationApi,
  reportGeneratorApi,
  aiDashboardApi,
  nodeAuthApi,
  nodeTaskApi,
  nodeGenAiTestApi,
  pythonTaskApi,
  documentsApi,
  controlGenApi,
};

export type { AnchUserInfo } from './user-profile';
